export const uiServerRequest: RequestInit = {
  method: 'GET',
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  },
};

// Runs before Angular (and fspApiHeadersInterceptor) exists, so the APIM
// headers the interceptor would normally add have to be set by hand. They are
// ignored when coreApiUrl points straight at the Core host.
export const generateCoreApiRequest = (
  token: string,
  subscriptionKey?: string,
  apiEnvironment?: string,
): RequestInit => ({
  method: 'GET',
  headers: {
    Authorization: `Bearer ${token}`,
    ...(subscriptionKey ? { 'x-subscription-key': subscriptionKey } : {}),
    ...(apiEnvironment ? { 'x-fsp-environment': apiEnvironment } : {}),
  },
});

export async function getJsonFromServer(fileName: string): Promise<unknown> {
  const response = await window.fetch(fileName, uiServerRequest);
  if (response.ok) {
    return await response.json();
  } else {
    const responseBody = await response.json();
    return Promise.reject(responseBody);
  }
}

export async function getRawFileFromServer(fileName: string): Promise<unknown> {
  const response = await window.fetch(fileName, uiServerRequest);
  if (response.ok) {
    return await response.text();
  } else {
    return Promise.reject();
  }
}

export async function getServerContext(): Promise<unknown> {
  try {
    const responseJson = await getJsonFromServer('/AppContext');
    return responseJson;
  } catch (e) {
    console.error(e);
    return Promise.reject(e);
  }
}
